export const AUTH_USER = 'ngStorage-user';
export const CLIENTS_TAG = 'ngStorage-vendorThemes';
export const VENDOR_ID_TAG = 'ngStorage-vi';
export const FEATURES_TAG = 'ngStorage-features';
export const CONFIG_TAG = 'ngStorage-client-config';
export const USER_PERMISSIONS_TAG = 'ngStorage-user-permissions';